


// import React, { Component } from 'react';
// import { Modal } from 'react-bootstrap';
// import styled from 'styled-components';
// import socket from "../../../Socket";
// import storage from "../../../Storage";
// import { decode, encode, isEmail, Event, wait, sendNotfication, API } from "../../../Helper";
// import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
// import C from "../../../Constant";
// import axios from 'axios';

// const StyledModal = styled(Modal)`
//   .modal-content {
//     background: #292d2e !important;
//     color: white;
//     border-radius: 12px;
//     overflow: hidden;
//     max-width: 800px;
//     margin: 0 auto;
//     display: flex;
//     flex-direction: column;
//     z-index: 999;
//        height: 90vh;
    
//     @media (min-width: 768px) {
//       flex-direction: row;
//     }
    
//     @media (max-width: 768px) {
//       // padding: 16px;
//       height: 100vh;
//       border-radius: 0;
//     }
//   }
  
//   .modal-dialog {
//     max-width: 900px;
//     margin: 0;
//     height: 100vh;
//     width: 100vw;
//     z-index: 9999;
    
//     @media (min-width: 768px) {
//       margin: 1.75rem auto;
//       height: auto;
//       width: auto;
//     }
//   }
  
//   &.modal {
//     z-index: 1060;
//   }
  
//   @media (max-width: 768px) {
//     margin: 0;
//     padding: 0;
    
//     &.modal-dialog-centered {
//       min-height: 100vh;
//       align-items: flex-start;
//     }
//   }
// `;

// const RightSection = styled.div`
//   flex: 1;
//   background-image: url('/assets/images/bcgames/signup/signup.png');
//   background-size: cover;
//   background-position: center;
//   position: relative;
//   background-repeat:no-repeat;
//   min-height: 160px;
//   display: flex;
//   flex-direction: column;
//   align-items:center;
//   justify-content: space-between;
//   padding: 30px;
//   object-fit: cover;
  
//   @media (min-width: 768px) {
//     min-height: 100vh;
//     background-position: center top;
//     overflow: hidden;
//     background-size: 100% auto;
//   }
  
//   @media (max-width: 768px) {
//     order: 1;
//     padding: 12px;
//     height: 90px;
//     min-height: auto;
//      background-image: url('/assets/images/bcgames/signup/signup.png');
//     background-position: top;
//     // background-size:contain;
//     justify-content: flex-end;
    
//     &::after {
//       content: '';
//       position: absolute;
//       bottom: 0;
//       left: 0;
//       right: 0;
//       height: 50%;
//       background: linear-gradient(to bottom, rgba(35, 38, 38, 0), rgba(35, 38, 38, 1));
//       pointer-events: none;
//     }
//   }
// `;

// const RightContent = styled.div`
//   position: relative;
//   z-index: 1;
//   color: white;
// `;

// const LeftSection = styled(Modal.Body)`
//   padding: 16px;
//   flex: 1;
//   position: relative;
//   width: 100%;
  
//   @media (max-width: 768px) {
//     padding: 24px;
//     order: 2;
//     // margin-top: -18px;
//   }
// `;

// const StayUntamed = styled.div`
//   h2 {
//     font-size: 28px;
//     font-weight: bold;
//     margin-bottom: 16px;
//     color: white;
//     text-align: center;
    
//     @media (max-width: 768px) {
//       font-size: 20px;
//       margin-bottom: 8px;
//       margin-top:-65px;
//     }
//   }

//   p {
//     font-size: 14px;
//     color: rgba(255, 255, 255, 0.8);
//     text-align: center;
    
//     @media (max-width: 768px) {
//       font-size: 12px;
//     }
//   }

//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const CloseButton = styled.button`
//   position: fixed;
//   right: 40px;
//   top: 47px;
//   background: rgba(255, 255, 255, 0.1);
//   border: none;
//   color: white;
//   font-size: 18px;
//   width: 32px;
//   height: 32px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   z-index: 10;
  
//   @media (min-width: 768px) {
//     position: absolute;
//   }
  
//   &:hover {
//     background: rgba(255, 255, 255, 0.2);
//   }
// `;

// const Title = styled.h2`
//   font-size: 24px;
//   color: white;
//   margin-bottom: 16px;

//   @media (max-width: 768px) {
//     font-size: 18px;
//     margin-bottom: 20px;
//     margin-top:-65px;
//   }
// `;

// const StyledForm = styled.form`
//   display: flex;
//   flex-direction: column;
//   gap: 10px;

//   @media (max-width: 768px) {
//     gap: 6px;
//   }
// `;

// const InputWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 4px;
// `;

// const StyledInput = styled.input`
//    background: rgba(0, 0, 0, 0.35);

//   border: 1px solid #272B30;
//   border-radius: 12px;
//   color: white;
//   padding: 8px 12px;
//   width: 100%;
//   font-size: 12px;

//   @media (max-width: 768px) {
//     // padding: 10px 12px;
//     font-size: 13px;
//     border-radius: 8px;
//   }

//   &::placeholder {
//     color: #fff;
//   }

//   &:focus {
//     outline: none;
//     border-color: #25ee89;
//   }

//   &::-webkit-outer-spin-button,
//   &::-webkit-inner-spin-button {
//     -webkit-appearance: none;
//     margin: 0;
//   }

//   &[type='number'] {
//     -moz-appearance: textfield;
//   }
// `;

// const Label = styled.div`
//   color: #fff;
//   font-size: 14px;
//   font-weight: 500;
  
//   @media (max-width: 768px) {
//     font-size: 12px;
//   }
// `;

// const CheckboxContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   margin: 2px 0;
// `;

// const CheckboxInput = styled.input`
//   width: 20px;
//   height: 20px;
//   cursor: pointer;
  
//   @media (max-width: 768px) {
//     width: 16px;
//     height: 16px;
//   }
// `;

// const CheckboxLabel = styled.label`
//   color: #fff;
//   font-size: 12px;
  
//   @media (max-width: 768px) {
//     font-size: 11px;
//   }
// `;

// const SignUpButton = styled.div`
//   background: #25ee89;
//   border: none;
//   border-radius: 12px;
//   text-align:center;
//   color: black !important;
//   padding: 12px 16px;
//   font-weight: 600;
//   font-size: 15px;
//   width: 100%;
//   cursor: pointer;
//   margin-top: 12px;

//   @media (max-width: 768px) {
//     padding: 10px 12px;
//     font-size: 14px;
//     margin-top:0px;
//     border-radius: 8px;
//   }

//   &:hover {
//     background-color:  #25ee89;
//   }

//   &:disabled {
//     opacity: 0.7;
//     cursor: not-allowed;
//   }
// `;

// const SignUpButtonO = styled.div`
//   font-size: 14px;
//   // background: #25ee89
//   background:#25ee89;
//   border-radius: 10px;
//   padding: 7px 14px;
//   font-weight: bold;
//   cursor: pointer;
//   color: black !important;
//   white-space: nowrap;

//   @media (max-width: 768px) {
//     width: 100%;
//     text-align: center;
//     font-size: 13px;
//     padding: 6px 12px;
//     border-radius: 8px;
//   }
// `;

// const SignInText = styled.div`
//   text-align: center;
//   margin-top: 24px;
//   color: #fff;
//   font-size: 14px;

//   @media (max-width: 768px) {
//     margin-top: 16px;
//     font-size: 12px;
//   }
// `;

// const SignInLink = styled.span`
//   color: #25ee89;
//   cursor: pointer;
//   margin-left: 8px;
//   font-weight: 500;

//   &:hover {
//     text-decoration: underline;
//   }
// `;

// const ModalClose = styled.div`
//   display: none;
//   @media (max-width: 768px) {
//     display: flex;
//     height: 30px;
//     width: 30px;
//     justify-content: center;
//     align-items: center;
//     border-radius: 20%;
//     background-color: #2D6A4D;
//     position: absolute;
//     padding: 12px;
//     top: -550px;
//     left: 299px;
//     z-index: 9999;
//   }
// `;

// const CountrySelectWrapper = styled.div`
//   select {
//     width: 100%;
//     background: rgba(0, 0, 0, 0.35);
//     border: 1px solid #272B30;
//     border-radius: 12px;
//     color: white;
//     padding: 8px 12px;
//     font-size: 12px;
//     appearance: none;
//     background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
//     background-repeat: no-repeat;
//     background-position: right 12px center;
//     background-size: 16px;
//     cursor: pointer;

//     @media (max-width: 768px) {
//       font-size: 13px;
//       border-radius: 8px;
//     }

//     &:focus {
//       outline: none;
//       border-color: #25ee89;
//     }

//     option {
//       background: #1E2124;
//       color: white;
//       padding: 8px;
//     }
//   }
// `;

// const FlagIcon = styled.span`
//   display: inline-block;
//   width: 20px;
//   height: 15px;
//   margin-right: 8px;
//   vertical-align: middle;
//   background-image: url(https://flagcdn.com/${props => props.countryCode.toLowerCase()}.svg);
//   background-size: cover;
//   background-position: center;
// `;
// // Add these styled components to your existing styled components

// const OtpSectionWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   padding: 1rem 0;
// `;

// const OtpDescription = styled.p`
//   font-size: 14px;
//   color: #666;
//   margin-bottom: 1.5rem;
//   text-align: center;
// `;

// const VerifyButton = styled.button`
//   width: 100%;
//   background-color:  #25ee89;
//   color: white;
//   padding: 12px;
//   margin-top: 1rem;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
//   font-size: 16px;
//   font-weight: 500;
//   transition: background-color 0.3s;

//   &:hover {
//     // background-color: #25ee89;
//   }

//   &:disabled {
//     background-color: #cccccc;
//     cursor: not-allowed;
//   }
// `;

// const ResendWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-top: 1rem;
// `;

// const ResendButton = styled.button`
//   background: none;
//   border: none;
//   color: #1a73e8;
//   cursor: pointer;
//   font-size: 14px;
//   text-decoration: underline;
  
//   &:hover {
//     color: #0d47a1;
//   }
// `;

// const ResendTimerText = styled.span`
//   color: #666;
//   font-size: 14px;
// `;

// const BackButton = styled.button`
//   background: none;
//   border: none;
//   color: #666;
//   cursor: pointer;
//   font-size: 14px;
//   margin-top: 1.5rem;
//   align-self: center;
  
//   &:hover {
//     color: #333;
//     text-decoration: underline;
//   }
// `;

// const VerifiedBadge = styled.div`
//   display: inline-flex;
//   align-items: center;
//   background-color: #e6f7e6;
//   color: #2e7d32;
//   padding: 4px 8px;
//   border-radius: 4px;
//   font-size: 12px;
//   margin-top: 5px;
// `;

// const CheckIcon = styled.span`
//   margin-left: 5px;
  
//   &:before {
//     content: '✓';
//   }
// `;
// class Register extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             isLogged: storage.getKey('logged'),
//             show: this.props.show ? this.props.show : false,
//             username: '',
//             email: '',
//             password: '',
//             phoneNumber: '',
//             referral: this.props.referral || '',
//             ruleChecked: false,
//             marketingChecked: false,
//             submitted: false,
//             disabled: false,
//             effect: 'zoomIn',
//             selectedCountry: null,
//             country: '',
//           // New OTP related state
//           otpSent: false,
//           otpVerified: false,
//           otp: '',
//           resendTimer: 0,
//           showOtpSection: false,
//         };
//         this.resendTimerInterval = null;
//     }

//     componentDidMount() {
//         socket.on(C.REGISTER_USER, data => this.setRegister(decode(data)));
//         Event.on('register_form', () => {
//             this.handleShow();
//         });
//     }
//     componentWillUnmount() {
//       // Clear timer interval if component unmounts
//       if (this.resendTimerInterval) {
//           clearInterval(this.resendTimerInterval);
//       }
//   }
  
//   handleCountryChange = (country) => {
//     this.setState({ selectedCountry: country });
// }

// setRegister = (data) => {
//     console.log('Received registration response:', data);
    
//     if (data.error) {
//         console.log('Registration error:', data.error);
//         this.setState({ disabled: false, submitted: false });
//         // sendNotfication(data.error, 'error', 'bottom-left');
//         return;
//     }

//     if (data.status) {
//         console.log('Registration successful');
//         this.setState({ submitted: false });
//         // sendNotfication('Registration successful!', 'success', 'bottom-left');
        
//         wait(1000).then(() => {
//             socket.emit(C.LOGIN_USER, encode({
//                 username: data.name,
//                 password: data.password,
//                 recaptcha: 'google'
//             }));
//         });
        
//         localStorage.setItem('showLoginSuccessModal', 'true');
//         this.handleClose();
//     }
// };

// handleShow = () => {
//     this.setState({ show: true, effect: 'zoomIn' });
// }
    
//     handleClose = () => {
//       this.setState({
//           show: false,
//           effect: 'zoomOut',
//           disabled: false,
//           submitted: false,
//           ruleChecked: false,
//           marketingChecked: false,
//           otpSent: false,
//           otpVerified: false,
//           otp: '',
//           showOtpSection: false,
//           resendTimer: 0
//       });
//       if (this.resendTimerInterval) {
//           clearInterval(this.resendTimerInterval);
//           this.resendTimerInterval = null;
//       }
//   }

//   verifyRefrelCode = async () => {
//       try {
//           const response = await axios.get(`${API}/verify-referral-code/${this.state.referral}`);
//           console.log(response);
//           console.log(response.data.valid);  // Access the valid field from response.data
//           return response.data.valid;  
//       } catch (error) {
//           console.log("error", error);
//           return false;
//       }
//   }

//        // Function to handle sending OTP
//        sendOtp = async () => {
//         const { email } = this.state;
        
//         // Basic validation
//         if (!email) {
//             sendNotfication('Please enter an email address', 'error', 'bottom-left');
//             return;
//         }
        
//         if (!isEmail(email)) {
//             sendNotfication('Please enter valid email address', 'error', 'bottom-left');
//             return;
//         }
        
//         try {
//             // Call the OTP send API
//             const response = await axios.post(`${API}/email/otp/send`, {
//                 email: email,
//                 purpose: 'register'
//             });
            
//             if (response.data.success) {
//                 // OTP sent successfully
//                 this.setState({ 
//                     otpSent: true,
//                     showOtpSection: true,
//                     resendTimer: 30
//                 });
//                 sendNotfication('OTP sent successfully to your email', 'success', 'bottom-left');
                
//                 // Start the resend timer
//                 this.startResendTimer();
                
//             } else {
//                 // Error sending OTP
//                 sendNotfication(response.data.error || 'Failed to send OTP', 'error', 'bottom-left');
//             }
//         } catch (error) {
//             console.error('Error sending OTP:', error);
//             sendNotfication('An error occurred while sending OTP', 'error', 'bottom-left');
//         }
//     }
    
//     // Function to verify OTP
//     verifyOtp = async () => {
//         const { email, otp } = this.state;
        
//         if (!otp) {
//             sendNotfication('Please enter the OTP', 'error', 'bottom-left');
//             return;
//         }
        
//         try {
//             const response = await axios.post(`${API}/email/otp/verify`, {
//                 email: email,
//                 otp: otp,
//                 purpose: 'register'
//             });
            
//             if (response.data.success) {
//                 // OTP verified successfully
//                 this.setState({ 
//                     otpVerified: true,
//                     showOtpSection: false
//                 });
//                 // sendNotfication('Email verified successfully!', 'success', 'bottom-left');
                
//                 // Clear the timer if it's running
//                 if (this.resendTimerInterval) {
//                     clearInterval(this.resendTimerInterval);
//                     this.resendTimerInterval = null;
//                 }
                
//                 // Proceed with registration after OTP verification
//                 this.finalizeRegistration();
                
//             } else {
//                 // Invalid OTP
//                 sendNotfication(response.data.error || 'Invalid OTP', 'error', 'bottom-left');
//             }
//         } catch (error) {
//             console.error('Error verifying OTP:', error);
//             sendNotfication('An error occurred while verifying OTP', 'error', 'bottom-left');
//         }
//     }
    
//     // Function to resend OTP
//     resendOtp = async () => {
//         const { email, resendTimer } = this.state;
        
//         // Check if timer has expired
//         if (resendTimer > 0) {
//             sendNotfication(`Please wait ${resendTimer} seconds before requesting another OTP`, 'warning', 'bottom-left');
//             return;
//         }
        
//         try {
//             const response = await axios.post(`${API}/email/otp/resend`, {
//                 email: email,
//                 purpose: 'register'
//             });
            
//             if (response.data.success) {
//                 // OTP resent successfully
//                 this.setState({ resendTimer: 30 });
//                 sendNotfication('OTP resent successfully', 'success', 'bottom-left');
                
//                 // Restart the timer
//                 this.startResendTimer();
                
//             } else {
//                 sendNotfication(response.data.error || 'Failed to resend OTP', 'error', 'bottom-left');
//             }
//         } catch (error) {
//             console.error('Error resending OTP:', error);
//             sendNotfication('An error occurred while resending OTP', 'error', 'bottom-left');
//         }
//     }
    
//     // Start the resend timer
//     startResendTimer = () => {
//         // Clear any existing interval
//         if (this.resendTimerInterval) {
//             clearInterval(this.resendTimerInterval);
//         }
        
//         this.resendTimerInterval = setInterval(() => {
//             this.setState(prevState => {
//                 if (prevState.resendTimer <= 1) {
//                     clearInterval(this.resendTimerInterval);
//                     this.resendTimerInterval = null;
//                     return { resendTimer: 0 };
//                 }
//                 return { resendTimer: prevState.resendTimer - 1 };
//             });
//         }, 1000);
//     }
//   //   handleSubmit = async (e) => {
//   //     console.log('Registration process started');
//   //     e.preventDefault();
      
//   //     this.setState({ submitted: true, disabled: true });
//   //     console.log('Form submission state updated - submitted: true, disabled: true');
      
//   //     const { username, email, password, ruleChecked, referral, phoneNumber, country } = this.state;
//   //     console.log('Form data:', {
//   //         username,
//   //         email,
//   //         hasPassword: !!password,
//   //         ruleChecked,
//   //         hasReferral: !!referral,
//   //         phoneNumber,
//   //         country
//   //     });
  
//   //     // Referral verification
//   //     if (referral && referral.trim()) {
//   //         console.log('Verifying referral code:', referral);
//   //         const verified = await this.verifyRefrelCode();
//   //         console.log('Referral verification result:', verified);
          
//   //         if (!verified) {
//   //             console.log('Invalid referral code - stopping registration');
//   //             this.setState({ disabled: false });
//   //             sendNotfication('Please enter valid referral code', 'error', 'bottom-left');
//   //             return;
//   //         }
//   //     }
  
//   //     // Required fields validation with specific error messages
//   //     if (!username) {
//   //         console.log('Username missing');
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please enter a username', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     if (!password) {
//   //         console.log('Password missing');
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please enter a password', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     if (!email) {
//   //         console.log('Email missing');
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please enter an email address', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     if (!ruleChecked) {
//   //         console.log('Terms not accepted');
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please accept the Terms of Service', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     // Username length validation
//   //     if (username.length < 5) {
//   //         console.log('Username too short:', username.length);
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please enter username more than 5 characters', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     // Email validation
//   //     if (!isEmail(email)) {
//   //         console.log('Invalid email format:', email);
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please enter valid email address', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     // Country validation
//   //     if (!country) {
//   //         console.log('Country not selected');
//   //         this.setState({ disabled: false });
//   //         sendNotfication('Please select country', 'error', 'bottom-left');
//   //         return;
//   //     }
  
//   //     try {
//   //         // Prepare registration data
//   //         const registrationData = {
//   //             username: username,
//   //             password: password,
//   //             email: email,
//   //             phone: phoneNumber,
//   //             method: true,
//   //             refree: referral || '',
//   //             country: country,
//   //             aff: storage.getKey('aff') ? storage.getKey('aff') : null
//   //         };
          
//   //         console.log('Sending registration data to server:', {
//   //             ...registrationData,
//   //             password: '[HIDDEN]' // Hide password in logs
//   //         });
  
//   //         // Emit registration event
//   //         socket.emit(C.REGISTER_USER, encode(registrationData));
//   //         console.log('Registration data sent to server');
  
//   //         // Don't close the form immediately - wait for server response
//   //         // The form will be closed in setRegister if registration is successful
//   //     } catch (error) {
//   //         console.error('Registration error:', error);
//   //         this.setState({ disabled: false });
//   //         sendNotfication('An error occurred during registration. Please try again.', 'error', 'bottom-left');
//   //     }
//   // }
//   //   handleInputChange = (e) => {
//   //       this.setState({ [e.target.name]: e.target.value });
//   //   }

//   //   checkRule = () => {
//   //       this.setState(prevState => ({ ruleChecked: !prevState.ruleChecked }));
//   //   }

//   //   checkMarketing = () => {
//   //       this.setState(prevState => ({ marketingChecked: !prevState.marketingChecked }));
//   //   }

//   //   login = () => {
//   //       this.handleClose();
//   //       Event.emit('login_form');
//   //   }
//   //   selectCountry = (val) => {
//   //     this.setState({ country: val });
//   // }
//   // Modified handleSubmit to first verify OTP before registration
//   handleSubmit = async (e) => {
//     console.log('Registration process started');
//     e.preventDefault();
    
//     this.setState({ submitted: true, disabled: true });
//     console.log('Form submission state updated - submitted: true, disabled: true');
    
//     const { username, email, password, ruleChecked, otpVerified } = this.state;
    
//     // Required fields validation with specific error messages
//     if (!username) {
//         console.log('Username missing');
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please enter a username', 'error', 'bottom-left');
//         return;
//     }

//     if (!password) {
//         console.log('Password missing');
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please enter a password', 'error', 'bottom-left');
//         return;
//     }

//     if (!email) {
//         console.log('Email missing');
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please enter an email address', 'error', 'bottom-left');
//         return;
//     }

//     if (!ruleChecked) {
//         console.log('Terms not accepted');
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please accept the Terms of Service', 'error', 'bottom-left');
//         return;
//     }

//     // Username length validation
//     if (username.length < 5) {
//         console.log('Username too short:', username.length);
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please enter username more than 5 characters', 'error', 'bottom-left');
//         return;
//     }

//     // Email validation
//     if (!isEmail(email)) {
//         console.log('Invalid email format:', email);
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please enter valid email address', 'error', 'bottom-left');
//         return;
//     }

//     // Country validation
//     if (!this.state.country) {
//         console.log('Country not selected');
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('Please select country', 'error', 'bottom-left');
//         return;
//     }
    
//     // If OTP is not yet verified, show OTP section
//     if (!otpVerified) {
//         this.sendOtp();
//         this.setState({ disabled: false, submitted: false });
//         return;
//     }
    
//     // Continue with referral verification and final registration
//     await this.continueWithReferralCheck();
// }

// // Continue with referral check after OTP verification
// continueWithReferralCheck = async () => {
//     const { referral } = this.state;
    
//     // Referral verification
//     if (referral && referral.trim()) {
//         console.log('Verifying referral code:', referral);
//         const verified = await this.verifyRefrelCode();
//         console.log('Referral verification result:', verified);
        
//         if (!verified) {
//             console.log('Invalid referral code - stopping registration');
//             this.setState({ disabled: false, submitted: false });
//             sendNotfication('Please enter valid referral code', 'error', 'bottom-left');
//             return;
//         }
//     }
    
//     // Finalize registration process
//     this.finalizeRegistration();
// }

// // Finalize registration after all validations
// finalizeRegistration = () => {
//     const { username, email, password, phoneNumber, referral, country } = this.state;
    
//     try {
//         // Prepare registration data
//         const registrationData = {
//             username: username,
//             password: password,
//             email: email,
//             phone: phoneNumber,
//             method: true,
//             refree: referral || '',
//             country: country,
//             aff: storage.getKey('aff') ? storage.getKey('aff') : null
//         };
        
//         console.log('Sending registration data to server:', {
//             ...registrationData,
//             password: '[HIDDEN]' // Hide password in logs
//         });

//         // Emit registration event
//         socket.emit(C.REGISTER_USER, encode(registrationData));
//         console.log('Registration data sent to server');

//         // Don't close the form immediately - wait for server response
//         // The form will be closed in setRegister if registration is successful
//     } catch (error) {
//         console.error('Registration error:', error);
//         this.setState({ disabled: false, submitted: false });
//         sendNotfication('An error occurred during registration. Please try again.', 'error', 'bottom-left');
//     }
// }

// handleInputChange = (e) => {
//     this.setState({ [e.target.name]: e.target.value });
// }

// checkRule = () => {
//     this.setState(prevState => ({ ruleChecked: !prevState.ruleChecked }));
// }

// checkMarketing = () => {
//     this.setState(prevState => ({ marketingChecked: !prevState.marketingChecked }));
// }

// login = () => {
//     this.handleClose();
//     Event.emit('login_form');
// }

// selectCountry = (val) => {
//     this.setState({ country: val });
// }
    
// render() {
//   const {
//       show,
//       username,
//       email,
//       password,
//       phoneNumber,
//       referral,
//       ruleChecked,
//       marketingChecked,
//       disabled,
//       selectedCountry,
//       showOtpSection,
//       otp,
//       resendTimer,
//       otpVerified
//   } = this.state;

//       return (
//           <>
//               <SignUpButtonO onClick={this.handleShow}>
//                   Sign up
//               </SignUpButtonO>
//               <StyledModal
//                   size="md"
//                   centered
//                   show={show}
//                   onHide={this.handleClose}
//                   aria-labelledby="register-modal"
//                   className={`animated ${this.state.effect}`}
//               >
//                   <CloseButton onClick={this.handleClose}>×</CloseButton>
//                   <RightSection>
//                       <RightContent>
//                           <ModalClose onClick={this.handleClose}>
//                               x
//                           </ModalClose>
//                       </RightContent>
//                       {/* <StayUntamed>
//                           <h2>Stay Untamed</h2>
//                           <p>Sign Up & Get Welcome Bonus</p>
//                       </StayUntamed> */}
//                   </RightSection>
//                   <LeftSection>
//                   <Title>{showOtpSection ? 'Verify Email' : 'Sign Up'}</Title>

//                       {showOtpSection? (
//                             <OtpSectionWrapper>
//                                 <OtpDescription>
//                                     We've sent a verification code to {email}. Please check your inbox and enter the code below.
//                                 </OtpDescription>
                                
//                                 <InputWrapper>
//                                     <Label htmlFor="otp">Verification Code</Label>
//                                     <StyledInput
//                                         type="text"
//                                         id="otp"
//                                         name="otp"
//                                         placeholder="Enter OTP"
//                                         value={otp}
//                                         onChange={this.handleInputChange}
//                                         required
//                                     />
//                                 </InputWrapper>
                                
//                                 <VerifyButton 
//                                     type="button" 
//                                     onClick={this.verifyOtp}
//                                     disabled={disabled}
//                                 >
//                                     Verify Code
//                                 </VerifyButton>
                                
//                                 <ResendWrapper>
//                                     {resendTimer > 0 ? (
//                                         <ResendTimerText>
//                                             Resend code in {resendTimer} seconds
//                                         </ResendTimerText>
//                                     ) : (
//                                         <ResendButton type="button" onClick={this.resendOtp}>
//                                             Resend Code
//                                         </ResendButton>
//                                     )}
//                                 </ResendWrapper>
                                
//                                 <BackButton type="button" onClick={() => this.setState({ showOtpSection: false })}>
//                                     Back to Sign Up
//                                 </BackButton>
//                             </OtpSectionWrapper>
//                         ) : (
//    <StyledForm onSubmit={this.handleSubmit}>
//                           <InputWrapper>
//                               <Label htmlFor="username">Username</Label>
//                               <StyledInput
//                                   type="text"
//                                   id="username"
//                                   name="username"
//                                   placeholder="Enter username"
//                                   value={username}
//                                   onChange={this.handleInputChange}
//                                   required
//                               />
//                           </InputWrapper>

//                           <InputWrapper>
//                               <Label htmlFor="email">Email</Label>
//                               <StyledInput
//                                   type="email"
//                                   id="email"
//                                   name="email"
//                                   placeholder="Enter email"
//                                   value={email}
//                                   onChange={this.handleInputChange}
//                                   required
//                               />
//                           </InputWrapper>

//                           <InputWrapper>
//                               <Label htmlFor="password">Password</Label>
//                               <StyledInput
//                                   type="password"
//                                   id="password"
//                                   name="password"
//                                   placeholder="Enter password"
//                                   value={password}
//                                   onChange={this.handleInputChange}
//                                   required
//                               />
//                           </InputWrapper>
//                           <InputWrapper>
//                                 <Label>Country</Label>
//                                 <CountrySelectWrapper>
//                                     <CountryDropdown
//                                         value={this.state.country}
//                                         onChange={this.selectCountry}
//                                         priorityOptions={["US", "GB", "CA", "AU"]}
//                                         valueType="short"
//                                     />
//                                 </CountrySelectWrapper>
//                             </InputWrapper>
//                           <InputWrapper>
//                               <Label htmlFor="phoneNumber">Phone Number (Optional)</Label>
//                               <StyledInput
//                                   type="tel"
//                                   id="phoneNumber"
//                                   name="phoneNumber"
//                                   placeholder="Enter phone number"
//                                   value={phoneNumber}
//                                   onChange={this.handleInputChange}
//                               />
//                           </InputWrapper>

//                           <InputWrapper>
//                               <Label htmlFor="referral">Referral Code (Optional)</Label>
//                               <StyledInput
//                                   type="text"
//                                   id="referral"
//                                   name="referral"
//                                   placeholder="Enter referral code"
//                                   value={referral}
//                                   onChange={this.handleInputChange}
//                               />
//                           </InputWrapper>

//                           <CheckboxContainer>
//                               <CheckboxInput
//                                   type="checkbox"
//                                   id="rules"
//                                   checked={ruleChecked}
//                                   onChange={this.checkRule}
//                                   required
//                               />
//                               <CheckboxLabel htmlFor="rules">
//                                   I agree to the Terms of Service and Privacy Policy
//                               </CheckboxLabel>
//                           </CheckboxContainer>

//                           <CheckboxContainer>
//                               <CheckboxInput
//                                   type="checkbox"
//                                   id="marketing"
//                                   checked={marketingChecked}
//                                   onChange={this.checkMarketing}
//                               />
//                               <CheckboxLabel htmlFor="marketing">
//                                   I agree to receive marketing communications
//                               </CheckboxLabel>
//                           </CheckboxContainer>

//                           <SignUpButton type="submit" onClick={this.handleSubmit}>
//                               Sign Up
//                           </SignUpButton>
//                       </StyledForm>
//                         )}
                   

//                       <SignInText>
//                           Already have an account?
//                           <SignInLink onClick={this.login}>Sign In</SignInLink>
//                       </SignInText>
//                   </LeftSection>
//               </StyledModal>
//           </>
//       );
//   }
// }

// export default Register;

//===================================



import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import socket from "../../../Socket";
import storage from "../../../Storage";
import { decode, encode, isEmail, Event, wait, sendNotfication, API } from "../../../Helper";
import { useGlassyNotifications } from "../../../Context/GlassyNotificationsContext";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import C from "../../../Constant";
import axios from 'axios';
import { Link } from 'react-router-dom';



const StyledModal = styled(Modal)`
  .modal-content {
    background: #292d2e !important;
    color: white;
    border-radius: 12px;
    overflow: hidden;
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    z-index: 999;
       height: 100vh;
    
    @media (min-width: 768px) {
      flex-direction: row;
    }
    
    @media (max-width: 768px) {
      // padding: 16px;
      height: 100vh;
      border-radius: 0;
    }
  }
  
  .modal-dialog {
    max-width: 900px;
    margin: 0;
    height: 100vh;
    width: 97vw;
    z-index: 9999;
    
    @media (min-width: 768px) {
      margin: 1.75rem auto;
      height: auto;
      width: 97vw;
    }
  }
  
  &.modal {
    z-index: 1060;
  }
  
  @media (max-width: 768px) {
    margin: 0;
    padding: 0;
    
    &.modal-dialog-centered {
      min-height: 100vh;
      align-items: flex-start;
    }
  }
`;

const RightSection = styled.div`
  flex: 1;
  background-image: url('/assets/images/bcgames/signup/signup8.png');
  
  background-size: cover;
  background-position: center;
  position: relative;
  background-repeat:no-repeat;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: space-between;
  padding: 65px 30px;
  object-fit: cover;
  
  @media (min-width: 768px) {
    min-height: 100vh;
    background-position: center top;
    overflow: hidden;
    
  }
  
  @media (max-width: 768px) {
    order: 1;
    padding: 12px;
    height: 90px;
    min-height: auto;
     background-image: url('/assets/images/bcgames/signup/signup8.png');
    background-position: top;
    background-size:cover;
    justify-content: center;
    margin-top:1rem;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
      background: linear-gradient(to bottom, rgba(35, 38, 38, 0), rgba(35, 38, 38, 1));
      pointer-events: none;
    }
  }
`;

const RightContent = styled.div`
  position: relative;
  z-index: 1;
  color: white;
`;

const LeftSection = styled(Modal.Body)`
  padding: 16px;
  flex: 1;
  position: relative;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 24px;
    order: 2;
    background:black;
    // margin-top: -18px;
  }
`;

const StayUntamed = styled.div`
  h2 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 16px;
    color: white;
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 20px;
      margin-bottom: 8px;
      margin-top:-65px;
    }
  }

  p {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const CloseButton = styled.button`
  position: fixed;
  right: 40px;
  top: 47px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 18px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  
  @media (min-width: 768px) {
    position: absolute;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const Title = styled.h2`
  font-size: 24px;
  color: white;
  margin-bottom: 16px;
font-family: 'Montserrat', sans-serif;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 20px;
    margin-top:-65px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledInput = styled.input`
   background: rgba(0, 0, 0, 0.35);

  border: 1px solid #272B30;
  border-radius: 12px;
  color: white;
  padding: 8px 12px;
  width: 100%;
  font-size: 12px;

  @media (max-width: 768px) {
    // padding: 10px 12px;
    font-size: 13px;
    border-radius: 8px;
  }

  &::placeholder {
    color: #fff;
  }

  &:focus {
    outline: none;
    border-color: #25ee89;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

const Label = styled.div`
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0;
`;

const CheckboxInput = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  
  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
  }
`;

const CheckboxLabel = styled.label`
  color: #fff;
  font-size: 12px;
  padding-top:2px;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

const SignUpButton = styled.div`
  background: #25ee89;
  border: none;
  border-radius: 12px;
  text-align:center;
  color: black !important;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 15px;
  width: 100%;
  cursor: pointer;
  margin-top: 12px;

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 14px;
    margin-top:0px;
    border-radius: 8px;
  }

  &:hover {
    background-color:  #25ee89;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const SignUpButtonO = styled.div`
  font-size: 14px;
  // background: #25ee89
  background:#25ee89;
  border-radius: 10px;
  padding: 7px 14px;
  font-weight: bold;
  cursor: pointer;
  color: black !important;
  white-space: nowrap;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: 13px;
    padding: 6px 12px;
    border-radius: 8px;
  }
`;

const SignInText = styled.div`
  text-align: center;
  margin-top: 10px;
  color: #fff;
  font-size: 14px;

  @media (max-width: 768px) {
    margin-top: 16px;
    font-size: 12px;
  }
`;
const TermsText = styled.div`
  text-align: left;
  margin-top: 10px;
  color:#25ee89;
  font-size: 10px;
  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    margin-top: 16px;
    font-size: 10px;
  }
`;

const SignInLink = styled.span`
  color: #25ee89;
  cursor: pointer;
  margin-left: 8px;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const ModalClose = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    height: 30px;
    width: 30px;
    justify-content: center;
    align-items: center;
    border-radius: 20%;
    background-color: #2D6A4D;
    position: absolute;
    padding: 12px;
    top: -550px;
    left: 299px;
    z-index: 9999;
  }
`;

const CountrySelectWrapper = styled.div`
  select {
    width: 100%;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid #272B30;
    border-radius: 12px;
    color: white;
    padding: 8px 12px;
    font-size: 12px;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    cursor: pointer;

    @media (max-width: 768px) {
      font-size: 13px;
      border-radius: 8px;
    }

    &:focus {
      outline: none;
      border-color: #25ee89;
    }

    option {
      background: #1E2124;
      color: white;
      padding: 8px;
    }
  }
`;

const FlagIcon = styled.span`
  display: inline-block;
  width: 20px;
  height: 15px;
  margin-right: 8px;
  vertical-align: middle;
  background-image: url(https://flagcdn.com/${props => props.countryCode.toLowerCase()}.svg);
  background-size: cover;
  background-position: center;
`;
// Add these styled components to your existing styled components

const OtpSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem 0;
`;

const OtpDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const VerifyButton = styled.button`
  width: 100%;
  background-color:  #25ee89;
  color: white;
  padding: 12px;
  margin-top: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.3s;

  &:hover {
    // background-color: #25ee89;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ResendWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const ResendButton = styled.button`
  background: none;
  border: none;
  color: #1a73e8;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  
  &:hover {
    color: #0d47a1;
  }
`;

const ResendTimerText = styled.span`
  color: #666;
  font-size: 14px;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  margin-top: 1.5rem;
  align-self: center;
  
  &:hover {
    color: #333;
    text-decoration: underline;
  }
`;

const VerifiedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #e6f7e6;
  color: #2e7d32;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 5px;
`;

const CheckIcon = styled.span`
  margin-left: 5px;
  
  &:before {
    content: '✓';
  }
`;

const FlipCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  
  margin: 40px auto 0;

  
  @media (max-width: 768px) {
    flex-direction: row;
    max-width: 100%;
    gap: 12px;
    justify-content: center;
    overflow-x: auto;
    padding: 0 12px;
    margin: 60px auto 0;
  }
`;

const CardImage = styled.img`
  width: 96px;
  height: 96px;
  object-fit: contain;
  flex-shrink: 0;
  transition: transform 0.5s ease-in-out;

  &:hover {
    transform: rotate(15deg);
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
  }
`;




const CardEmoji = styled.span`
  font-size: 72px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const CardSubtitle = styled.p`
  font-size: 24px;
  margin: 0;
  opacity: 0.9;
  text-align: left;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 16px;
    text-align: center;
  }
`;

const FrontContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
  }
`;

const FlipContainer = styled.div`
  perspective: 1000px;
  width: 100%;
  height: 7rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.02);
  }
  
  @media (max-width: 768px) {
    height: 9rem;
    width: 100px;
    flex-shrink: 0;
    
    &:hover {
      transform: none;
    }
  }
`;

const Flipper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  ${(props) =>
    props.flipped &&
    css`
      transform: rotateY(180deg);
    `}
`;

const CardFace = css`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 0.75rem;
`;

const Front = styled.div`
  ${CardFace}
`;

const Back = styled.div`
  ${CardFace}
  transform: rotateY(180deg);
`;

// Wrapper to inject glassy notifications into class component
const RegisterWithNotifications = (props) => {
  const { notify } = useGlassyNotifications();
  return <Register {...props} notify={notify} />;
};

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogged: storage.getKey('logged'),
            show: this.props.show ? this.props.show : false,
            username: '',
            email: '',
            password: '',
            phoneNumber: '',
            referral: this.props.referral || '',
            ruleChecked: false,
            marketingChecked: false,
            submitted: false,
            disabled: false,
            effect: 'zoomIn',
            selectedCountry: null,
            country: 'IN',
          // New OTP related state
          otpSent: false,
          otpVerified: false,
          otp: '',
          resendTimer: 0,
          showOtpSection: false,
          // Flip cards state
          flipped: Array(3).fill(false),
        };
        this.resendTimerInterval = null;
        // Cards data for flip section
        this.cards = [
            {
                img: '/assets/images/avatar/sport_bonus.png',
                title: '100% up to 1 BTC',
                subtitle: 'Welcome sports bonus',
                bg: 'linear-gradient(90deg, rgba(240, 156, 6, 0.3), rgba(30, 35, 40, 0.9))'
            },
            {
                img: '/assets/images/avatar/casino_bonus.png',
                title: 'Up to 4 BTC + 100 FS',
                subtitle: 'Welcome casino package',
                bg: 'linear-gradient(135deg, rgb(245, 158, 11) 0%, rgb(14 0 0) 100%)'
            },
            {
                img: '/assets/images/avatar/later.png',
                title: 'Enjoy the game',
                subtitle: 'Claim bonus later',
                bg: 'linear-gradient(90deg, rgba(240, 156, 6, 0.3), rgba(30, 35, 40, 0.9))'
            }
        ];
    }

    componentDidMount() {
         socket.off(C.REGISTER);
        socket.on(C.REGISTER_USER, data => this.setRegister(decode(data)));
        Event.on('register_form', () => {
            this.handleShow();
        });
    }
    componentWillUnmount() {
      // Clear timer interval if component unmounts
          socket.off(C.REGISTER, this.setRegister);
      if (this.resendTimerInterval) {
          clearInterval(this.resendTimerInterval);
      }
  }
  
  handleCountryChange = (country) => {
    this.setState({ selectedCountry: country });
}

  // Flip card methods
  handleFlip = (index) => {
      const newFlipped = [...this.state.flipped];
      newFlipped[index] = !newFlipped[index];
      if (index + 1 < this.cards.length) {
          newFlipped[index + 1] = !newFlipped[index + 1];
      }
      this.setState({ flipped: newFlipped });
  };

setRegister = (data) => {
    console.log('Received registration response:', data);
    
    if (data.error) {
        console.log('Registration error:', data.error);
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: data.error, type: 'error', position: 'bottom-left' });
        return;
    }

    if (data.status) {
        console.log('Registration successful');
        this.setState({ submitted: false });
        // this.props.notify({ message: 'Registration successful!', type: 'success', position: 'bottom-left' });
        
        wait(1000).then(() => {
            socket.emit(C.LOGIN_USER, encode({
                username: data.name,
                password: data.password,
                recaptcha: 'google'
            }));
        });
        
        localStorage.setItem('showLoginSuccessModal', 'true');
        this.handleClose();
    }
};

handleShow = () => {
    this.setState({ show: true, effect: 'zoomIn' });
}
    
    handleClose = () => {
      this.setState({
          show: false,
          effect: 'zoomOut',
          disabled: false,
          submitted: false,
          ruleChecked: false,
          marketingChecked: false,
          otpSent: false,
          otpVerified: false,
          otp: '',
          showOtpSection: false,
          resendTimer: 0
      });
      if (this.resendTimerInterval) {
          clearInterval(this.resendTimerInterval);
          this.resendTimerInterval = null;
      }
  }

  verifyRefrelCode = async () => {
      try {
          const response = await axios.get(`${API}/verify-referral-code/${this.state.referral}`);
          console.log(response);
          console.log(response.data.valid);  // Access the valid field from response.data
          return response.data.valid;  
      } catch (error) {
          console.log("error", error);
          return false;
      }
  }

       // Function to handle sending OTP
       sendOtp = async () => {
        const { email } = this.state;
        
        // Basic validation
        if (!email) {
            this.props.notify({ message: 'Please enter an email address', type: 'error', position: 'bottom-left' });
            return;
        }
        
        if (!isEmail(email)) {
            this.props.notify({ message: 'Please enter valid email address', type: 'error', position: 'bottom-left' });
            return;
        }
        
        try {
            // Call the OTP send API
            const response = await axios.post(`${API}/email/otp/send`, {
                email: email,
                purpose: 'register'
            });
            
            if (response.data.success) {
                // OTP sent successfully
                this.setState({ 
                    otpSent: true,
                    showOtpSection: true,
                    resendTimer: 30
                });
                this.props.notify({ message: 'OTP sent successfully to your email ,Please Check Junk or spam Folers In Email', type: 'success', position: 'bottom-left' });
                
                // Start the resend timer
                this.startResendTimer();
                
            } else {
                // Error sending OTP
                this.props.notify({ message: response.data.error || 'Failed to send OTP', type: 'error', position: 'bottom-left' });
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
            this.props.notify({ message: 'An error occurred while sending OTP', type: 'error', position: 'bottom-left' });
        }
    }
    
    // Function to verify OTP
    verifyOtp = async () => {
        const { email, otp } = this.state;
        
        if (!otp) {
            this.props.notify({ message: 'Please enter the OTP', type: 'error', position: 'bottom-left' });
            return;
        }
        
        try {
            const response = await axios.post(`${API}/email/otp/verify`, {
                email: email,
                otp: otp,
                purpose: 'register'
            });
            
            if (response.data.success) {
                // OTP verified successfully
                this.setState({ 
                    otpVerified: true,
                    showOtpSection: false
                });
                // sendNotfication('Email verified successfully!', 'success', 'bottom-left');
                
                // Clear the timer if it's running
                if (this.resendTimerInterval) {
                    clearInterval(this.resendTimerInterval);
                    this.resendTimerInterval = null;
                }
                
                // Proceed with registration after OTP verification
                this.finalizeRegistration();
                
            } else {
                // Invalid OTP
                this.props.notify({ message: response.data.error || 'Invalid OTP', type: 'error', position: 'bottom-left' });
            }
        } catch (error) {
            console.error('Error verifying OTP:', error);
            this.props.notify({ message: 'An error occurred while verifying OTP', type: 'error', position: 'bottom-left' });
        }
    }
    
    // Function to resend OTP
    resendOtp = async () => {
        const { email, resendTimer } = this.state;
        
        // Check if timer has expired
        if (resendTimer > 0) {
            this.props.notify({ message: `Please wait ${resendTimer} seconds before requesting another OTP`, type: 'warning', position: 'bottom-left' });
            return;
        }
        
        try {
            const response = await axios.post(`${API}/email/otp/resend`, {
                email: email,
                purpose: 'register'
            });
            
            if (response.data.success) {
                // OTP resent successfully
                this.setState({ resendTimer: 30 });
                this.props.notify({ message: 'OTP resent successfully', type: 'success', position: 'bottom-left' });
                
                // Restart the timer
                this.startResendTimer();
                
            } else {
                this.props.notify({ message: response.data.error || 'Failed to resend OTP', type: 'error', position: 'bottom-left' });
            }
        } catch (error) {
            console.error('Error resending OTP:', error);
            this.props.notify({ message: 'An error occurred while resending OTP', type: 'error', position: 'bottom-left' });
        }
    }
    
    // Start the resend timer
    startResendTimer = () => {
        // Clear any existing interval
        if (this.resendTimerInterval) {
            clearInterval(this.resendTimerInterval);
        }
        
        this.resendTimerInterval = setInterval(() => {
            this.setState(prevState => {
                if (prevState.resendTimer <= 1) {
                    clearInterval(this.resendTimerInterval);
                    this.resendTimerInterval = null;
                    return { resendTimer: 0 };
                }
                return { resendTimer: prevState.resendTimer - 1 };
            });
        }, 1000);
    }
  //   handleSubmit = async (e) => {
  //     console.log('Registration process started');
  //     e.preventDefault();
      
  //     this.setState({ submitted: true, disabled: true });
  //     console.log('Form submission state updated - submitted: true, disabled: true');
      
  //     const { username, email, password, ruleChecked, referral, phoneNumber, country } = this.state;
  //     console.log('Form data:', {
  //         username,
  //         email,
  //         hasPassword: !!password,
  //         ruleChecked,
  //         hasReferral: !!referral,
  //         phoneNumber,
  //         country
  //     });
  
  //     // Referral verification
  //     if (referral && referral.trim()) {
  //         console.log('Verifying referral code:', referral);
  //         const verified = await this.verifyRefrelCode();
  //         console.log('Referral verification result:', verified);
          
  //         if (!verified) {
  //             console.log('Invalid referral code - stopping registration');
  //             this.setState({ disabled: false });
  //             sendNotfication('Please enter valid referral code', 'error', 'bottom-left');
  //             return;
  //         }
  //     }
  
  //     // Required fields validation with specific error messages
  //     if (!username) {
  //         console.log('Username missing');
  //         this.setState({ disabled: false });
  //         sendNotfication('Please enter a username', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     if (!password) {
  //         console.log('Password missing');
  //         this.setState({ disabled: false });
  //         sendNotfication('Please enter a password', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     if (!email) {
  //         console.log('Email missing');
  //         this.setState({ disabled: false });
  //         sendNotfication('Please enter an email address', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     if (!ruleChecked) {
  //         console.log('Terms not accepted');
  //         this.setState({ disabled: false });
  //         sendNotfication('Please accept the Terms of Service', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     // Username length validation
  //     if (username.length < 5) {
  //         console.log('Username too short:', username.length);
  //         this.setState({ disabled: false });
  //         sendNotfication('Please enter username more than 5 characters', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     // Email validation
  //     if (!isEmail(email)) {
  //         console.log('Invalid email format:', email);
  //         this.setState({ disabled: false });
  //         sendNotfication('Please enter valid email address', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     // Country validation
  //     if (!country) {
  //         console.log('Country not selected');
  //         this.setState({ disabled: false });
  //         sendNotfication('Please select country', 'error', 'bottom-left');
  //         return;
  //     }
  
  //     try {
  //         // Prepare registration data
  //         const registrationData = {
  //             username: username,
  //             password: password,
  //             email: email,
  //             phone: phoneNumber,
  //             method: true,
  //             refree: referral || '',
  //             country: country,
  //             aff: storage.getKey('aff') ? storage.getKey('aff') : null
  //         };
          
  //         console.log('Sending registration data to server:', {
  //             ...registrationData,
  //             password: '[HIDDEN]' // Hide password in logs
  //         });
  
  //         // Emit registration event
  //         socket.emit(C.REGISTER_USER, encode(registrationData));
  //         console.log('Registration data sent to server');
  
  //         // Don't close the form immediately - wait for server response
  //         // The form will be closed in setRegister if registration is successful
  //     } catch (error) {
  //         console.error('Registration error:', error);
  //         this.setState({ disabled: false });
  //         sendNotfication('An error occurred during registration. Please try again.', 'error', 'bottom-left');
  //     }
  // }
  //   handleInputChange = (e) => {
  //       this.setState({ [e.target.name]: e.target.value });
  //   }

  //   checkRule = () => {
  //       this.setState(prevState => ({ ruleChecked: !prevState.ruleChecked }));
  //   }

  //   checkMarketing = () => {
  //       this.setState(prevState => ({ marketingChecked: !prevState.marketingChecked }));
  //   }

  //   login = () => {
  //       this.handleClose();
  //       Event.emit('login_form');
  //   }
  //   selectCountry = (val) => {
  //     this.setState({ country: val });
  // }
  // Modified handleSubmit to first verify OTP before registration
  handleSubmit = async (e) => {
    console.log('Registration process started');
    e.preventDefault();
    
    this.setState({ submitted: true, disabled: true });
    console.log('Form submission state updated - submitted: true, disabled: true');
    
    const { username, email, password, ruleChecked, otpVerified,phoneNumber } = this.state;
    
    // Required fields validation with specific error messages
    if (!username) {
        console.log('Username missing');
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please enter a username', type: 'error', position: 'bottom-left' });
        return;
    }

    if (!password) {
        console.log('Password missing');
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please enter a password', type: 'error', position: 'bottom-left' });
        return;
    }

    if (!email) {
        console.log('Email missing');
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please enter an email address', type: 'error', position: 'bottom-left' });
        return;
    }

    if (!ruleChecked) {
        console.log('Terms not accepted');
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please accept the Terms of Service', type: 'error', position: 'bottom-left' });
        return;
    }



    // Email validation
    if (!isEmail(email)) {
        console.log('Invalid email format:', email);
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please enter valid email address', type: 'error', position: 'bottom-left' });
        return;
    }

     if(phoneNumber.length < 10) {
        console.log('Phone number missing');  
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please enter a phone number', type: 'error', position: 'bottom-left' });
        return;
    }

    // Country validation
    if (!this.state.country) {
        console.log('Country not selected');
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'Please select country', type: 'error', position: 'bottom-left' });
        return;
    }
    
    // If OTP is not yet verified, show OTP section
    // if (!otpVerified) {
    //     this.sendOtp();
    //     this.setState({ disabled: false, submitted: false });
    //     return;
    // }
    
    // Continue with referral verification and final registration
    await this.continueWithReferralCheck();
}

// Continue with referral check after OTP verification
continueWithReferralCheck = async () => {
    const { referral } = this.state;
    
    // Referral verification
    if (referral && referral.trim()) {
        console.log('Verifying referral code:', referral);
        const verified = await this.verifyRefrelCode();
        console.log('Referral verification result:', verified);
        
        if (!verified) {
            console.log('Invalid referral code - stopping registration');
            this.setState({ disabled: false, submitted: false });
            this.props.notify({ message: 'Please enter valid referral code', type: 'error', position: 'bottom-left' });
            return;
        }
    }
    
    // Finalize registration process
    this.finalizeRegistration();
}

// Finalize registration after all validations
finalizeRegistration = () => {
    const { username, email, password, phoneNumber, referral, country } = this.state;
    
    try {
        // Prepare registration data
        const registrationData = {
            username: username,
            password: password,
            email: email,
            phone: phoneNumber,
            method: true,
            refree: referral || '',
            country: country,
            aff: storage.getKey('aff') ? storage.getKey('aff') : null
        };
        
        console.log('Sending registration data to server:', {
            ...registrationData,
            password: '[HIDDEN]' // Hide password in logs
        });

        // Emit registration event
        socket.emit(C.REGISTER_USER, encode(registrationData));
        console.log('Registration data sent to server');

        // Don't close the form immediately - wait for server response
        // The form will be closed in setRegister if registration is successful
    } catch (error) {
        console.error('Registration error:', error);
        this.setState({ disabled: false, submitted: false });
        this.props.notify({ message: 'An error occurred during registration. Please try again.', type: 'error', position: 'bottom-left' });
    }
}

handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
}

checkRule = () => {
    this.setState(prevState => ({ ruleChecked: !prevState.ruleChecked }));
}

checkMarketing = () => {
    this.setState(prevState => ({ marketingChecked: !prevState.marketingChecked }));
}

login = () => {
    this.handleClose();
    Event.emit('login_form');
}

selectCountry = (val) => {
    this.setState({ country: val });
}
    
render() {
  const {
      show,
      username,
      email,
      password,
      phoneNumber,
      referral,
      ruleChecked,
      marketingChecked,
      disabled,
      selectedCountry,
      showOtpSection,
      otp,
      resendTimer,
      otpVerified
  } = this.state;

      return (
          <>
              <SignUpButtonO onClick={this.handleShow}>
                  Sign up
              </SignUpButtonO>
              <StyledModal
                  size="md"
                  centered
                  show={show}
                  onHide={this.handleClose}
                  aria-labelledby="register-modal"
                  className={`animated ${this.state.effect}`}
              >
                  <CloseButton onClick={this.handleClose}>×</CloseButton>
                  <RightSection>
                     
                      {/* section flip cards */}
                      <FlipCardsContainer>
                          {this.cards.map((card, i) => (
                              <FlipContainer key={i} onClick={() => this.handleFlip(i)}>
                                  <Flipper flipped={this.state.flipped[i]}>
                                      <Front style={{ 
                                          background: card.bg, 
                                          borderRadius: '12px', 
                                          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                                          padding: '16px', 
                                          display: 'flex', 
                                          alignItems: 'center', 
                                          justifyContent: 'center', 
                                          color: 'white' 
                                      }}>
                                          <FrontContent>
                                              {card.img.startsWith('/') ? (
                                                  <CardImage src={card.img} alt="bonus" />
                                              ) : (
                                                  <CardEmoji>{card.img}</CardEmoji>
                                              )}
                                              <CardSubtitle>{card.subtitle}</CardSubtitle>
                                          </FrontContent>
                                      </Front>
                                      <Back style={{ 
                                          background: card.bg, 
                                          borderRadius: '12px', 
                                          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', 
                                          padding: '16px', 
                                          display: 'flex', 
                                          alignItems: 'center', 
                                          justifyContent: 'center', 
                                          color: 'white' 
                                      }}>
                                          <div style={{ textAlign: 'center' }}>
                                              <Title style={{ fontSize: '18px', margin: 0, fontWeight: '600', fontFamily: "'Montserrat', sans-serif" }}>{card.title}</Title>
                                          </div>
                                      </Back>
                                  </Flipper>
                              </FlipContainer>
                          ))}
                      </FlipCardsContainer>
                  </RightSection>
                  <LeftSection>
                  <Title>{showOtpSection ? 'Verify Email' : 'Sign Up'}</Title>

                      {showOtpSection? (
                            <OtpSectionWrapper>
                                <OtpDescription>
                                    We've sent a verification code to {email}. Please check your inbox and enter the code below.
                                </OtpDescription>
                                
                                <InputWrapper>
                                    <Label htmlFor="otp">Verification Code</Label>
                                    <StyledInput
                                        type="text"
                                        id="otp"
                                        name="otp"
                                        placeholder="Enter OTP"
                                        value={otp}
                                        onChange={this.handleInputChange}
                                        required
                                    />
                                </InputWrapper>
                                
                                <VerifyButton 
                                    type="button" 
                                    onClick={this.verifyOtp}
                                    disabled={disabled}
                                >
                                    Verify Code
                                </VerifyButton>
                                
                                <ResendWrapper>
                                    {resendTimer > 0 ? (
                                        <ResendTimerText>
                                            Resend code in {resendTimer} seconds
                                        </ResendTimerText>
                                    ) : (
                                        <ResendButton type="button" onClick={this.resendOtp}>
                                            Resend Code
                                        </ResendButton>
                                    )}
                                </ResendWrapper>
                                
                                <BackButton type="button" onClick={() => this.setState({ showOtpSection: false })}>
                                    Back to Sign Up
                                </BackButton>
                            </OtpSectionWrapper>
                        ) : (
   <StyledForm onSubmit={this.handleSubmit}>
                          <InputWrapper>
                              <Label htmlFor="username">Username</Label>
                              <StyledInput
                                  type="text"
                                  id="username"
                                  name="username"
                                  placeholder="Enter username"
                                  value={username}
                                  onChange={this.handleInputChange}
                                  required
                              />
                          </InputWrapper>

                          <InputWrapper>
                              <Label htmlFor="email">Email</Label>
                              <StyledInput
                                  type="email"
                                  id="email"
                                  name="email"
                                  placeholder="Enter email"
                                  value={email}
                                  onChange={this.handleInputChange}
                                  required
                              />
                          </InputWrapper>

                          <InputWrapper>
                              <Label htmlFor="password">Password</Label>
                              <StyledInput
                                  type="password"
                                  id="password"
                                  name="password"
                                  placeholder="Enter password"
                                  value={password}
                                  onChange={this.handleInputChange}
                                  required
                              />
                          </InputWrapper>
                          <InputWrapper>
                                <Label>Country</Label>
                                <CountrySelectWrapper>
                                    <CountryDropdown
                                        value={this.state.country}
                                        onChange={this.selectCountry}
                                        priorityOptions={["US", "GB", "CA", "AU"]}
                                        valueType="short"
                                    />
                                </CountrySelectWrapper>
                            </InputWrapper>
                          <InputWrapper>
                              <Label htmlFor="phoneNumber">Phone Number </Label>
                              <StyledInput
                                  type="tel"
                                  id="phoneNumber"
                                  name="phoneNumber"
                                  placeholder="Enter phone number"
                                  value={phoneNumber}
                                  onChange={this.handleInputChange}
                              />
                          </InputWrapper>

                          <InputWrapper>
                              <Label htmlFor="referral">Referral Code </Label>
                              <StyledInput
                                  type="text"
                                  id="referral"
                                  name="referral"
                                  placeholder="Enter referral code"
                                  value={referral}
                                  onChange={this.handleInputChange}
                              />
                          </InputWrapper>

                          <CheckboxContainer>
                              <CheckboxInput
                                  type="checkbox"
                                  id="rules"
                                  checked={ruleChecked}
                                  onChange={this.checkRule}
                                  required
                              />
                             <CheckboxLabel htmlFor="rules">
  I agree to the{" "}
  <a href="/provably-fair" target="_blank" rel="noopener noreferrer" style={{ color: '#25ee89', textDecoration: 'underline' }}>
    Terms of Service
  </a>{" "}
  and{" "}
  <a href="/provably-fair" target="_blank" rel="noopener noreferrer" style={{ color: '#25ee89', textDecoration: 'underline' }}>
    Privacy Policy
  </a>
</CheckboxLabel>
                          </CheckboxContainer>

                          <CheckboxContainer>
                              <CheckboxInput
                                  type="checkbox"
                                  id="marketing"
                                  checked={marketingChecked}
                                  onChange={this.checkMarketing}
                              />
                              <CheckboxLabel htmlFor="marketing">
                                  I agree to receive marketing communications
                              </CheckboxLabel>
                          </CheckboxContainer>

                          <SignUpButton type="submit" onClick={this.handleSubmit}>
                              Sign Up
                          </SignUpButton>
                      </StyledForm>
                        )}
                      
                       <SignInText>
                          Already have an account?
                          <SignInLink onClick={this.login}>Sign In</SignInLink>
                      </SignInText>
                   

                     
                  </LeftSection>
              </StyledModal>
          </>
      );
  }
}

export default RegisterWithNotifications;